import React, {PropsWithChildren} from "react";
import {NavLink} from "react-router-dom";
import clsx from "clsx";
import {buildLinkUrl} from "@router/RouterUtils";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";

export interface PageSectionProps extends PropsWithChildren {
    title?: string | null;
    subTitle?: string | null;
    description?: string | null;
    bg?: "dark" | "light" | "default";
    link?: {
        label?: string | null;
        href?: string | null;
    } | null;
    className?: string;
}

const PageSection = ({title, subTitle, description, bg = "default", link, className, children}: PageSectionProps) => {

    const c = clsx([
        "page-section",
        "bg-" + bg,
        className
    ]);

    if (!children) {
        return null;
    }

    return (
        <div className={c}>
            <div className="container">

                {(!!title || !!subTitle || !!link) &&
                    <>
                        <div className="page-section__header">
                            <div>
                                {!!title &&
                                    <h2 className={"tp-2xl"} dangerouslySetInnerHTML={{__html: title}}/>
                                }
                                {!!subTitle &&
                                    <h3 className={"tp-xl"} dangerouslySetInnerHTML={{__html: subTitle}}/>
                                }
                                {!!link &&
                                    <div className="page-section__header__actions">
                                        <NavLink to={buildLinkUrl(link.href)} className={"tp-xs color-primary semibold"}>
                                            <span className={"label"}>{link.label}</span>
                                            <span className={"icon"}>
                                                <ChevronRightIcon/>
                                            </span>
                                        </NavLink>
                                    </div>
                                }
                            </div>
                            {!!description &&
                                <p className={"tp-s"} dangerouslySetInnerHTML={{__html: description}}/>
                            }
                        </div>
                    </>
                }

                <div className="page-section__content">{children}</div>

            </div>
        </div>
    );

}

export default PageSection;